export default __webpack_public_path__ + "static/more-press-hover-c35ef98194fe1273b33716046bc96fcb.jpg";